
import React from "react";
import { useState, useEffect } from 'react';
//React Router
import { Navigate, useNavigate, useParams } from 'react-router-dom'

import dayjs from 'dayjs';

//Utils
import { checkLogin } from '../../../utils/check-login.js'

//selectors for redux :
import { useSelector, useDispatch } from "react-redux";
import { getContratStep, getSpotsList, getIdSpotLoc } from "../../../store/selectors.js"; //global state : contrat state

import { spotsListSlice } from "../../../store/spotsListSlice.js";
import { contratSlice } from "../../../store/contratSlice.js";
import { contratStepSlice } from "../../../store/contratStepSlice.js";
import { accessoiresSlice } from "../../../store/accessoiresSlice.js";
import { checkCGVSlice } from "../../../store/checkCGVSlice.js";
import { commentaireSlice } from "../../../store/commentaireSlice.js";
import { dureeSlice } from "../../../store/dureeSlice.js";
import { livraisonSlice } from "../../../store/livraisonSlice.js";
import { panierSlice } from "../../../store/panierSlice.js";
import { periodHeuresSlice } from "../../../store/periodSlice.js";
import { periodDatesSlice } from "../../../store/periodSlice.js";
import { userDataSlice } from "../../../store/userDataSlice.js";
import { idSpotLocSlice } from "../../../store/idSpotLocSlice.js";


import Button from '@mui/material/Button';

// API fetch
import axios from "axios";
import { baseURL } from '../../../config/api-config.js';

//import created compnenets
import StepOne from './step1/layout/stepone/StepOne' //component for step 1 : location picker, dates and times picker
import StepTwo from '../contrat/step2/layout/steptwo/StepTwo' //component for step 2 : Shopping Gallery + reminder
import StepThree from '../contrat/step3/layout/stepthree/StepThree' //component for step 2 : Shopping Gallery + reminder
import StepFour from '../contrat/step4/layout/stepfour/StepFour' //component for step 2 : Shopping Gallery + reminder
import StepFive from '../contrat/step5/layout/stepfive/StepFive' //component for step 2 : Shopping Gallery + reminder
import StepSix from './step6/layout/stepsix/StepSix' //component for step 2 : Shopping Gallery + reminder
import StepSeven from './step7/layout/stepseven/StepSeven' //component for step 2 : Shopping Gallery + reminder
import BannerMoutchicLoisirs from "../../../commons/bannerMoutchicLoisirs/BannerMoutchicLoisirs.jsx";
import ManagerNavBar from "../../../components/managernavbar/ManagerNavBar.jsx"; //<ManagerNavBar idSpotLoc={idSpotLoc} />
import { getContratByRef } from "../../../database/fetchApi.js";


// Contrat (ex navigator) is the main block, managing navigation step by step
function EditContrat() {

    const { idContrat, refContrat } = useParams();

    const [currentContrat, setCurrentContrat] = useState({});

    const dispatch = useDispatch();
    const step = useSelector(getContratStep) //global state : contrat step
    const idSpotLoc = useSelector(getIdSpotLoc) //global state : contrat step

    //const listSpots = useSelector(getSpotsList);

    axios.get(baseURL + "/spot").then((response) => {
        dispatch(spotsListSlice.actions.setSpotsList(response.data));
        console.log(response.data)

    });

    const navigate = useNavigate();

    useEffect(() => { //change opening hours when spot change (idspot as dependency)

        //if (idSpotLoc === 0) { navigate("../manager/"); }

        if (checkLogin() === false) {
            navigate("/manager/login/home");
        }; // if no login, no token, go to login page

        async function initContrat() { //we add this inner function to manage asynchrone

            let contrat = await getContratByRef(refContrat);
            setCurrentContrat(contrat)
        } //end of async function
        initContrat(); //call the inner asnchrone function

    }, [])

    useEffect(() => { //change opening hours when spot change (idspot as dependency)

        //first, reset everything
        dispatch(contratSlice.actions.setContrat({})); //reset contrat
        dispatch(accessoiresSlice.actions.resetPanier()); //reset access
        dispatch(checkCGVSlice.actions.resetCGV()); //reset cvg
        dispatch(commentaireSlice.actions.setCommentaire("")); //reset commentaire
        dispatch(dureeSlice.actions.setDuree({})); //reset duree
        dispatch(livraisonSlice.actions.setLivraison({})); //reset livraiosn
        dispatch(panierSlice.actions.resetPanier()); //reset access

        //dispatch(periodHeuresSlice.actions.setHeure([0, 0])); //reset access
        //dispatch(periodDatesSlice.actions.setDate([dayjs().format('YYYY-MM-DD'), dayjs().format('YYYY-MM-DD')])); //reset access

        dispatch(userDataSlice.actions.setUserData({
            found: false,
            id_client: 0,
            tel: "",
            email: "",
            prenom: "",
            nom: "",
            adresse: "",
            adresse_comp: "",
            cp: "",
            ville: "",
            pays: ""
        })); //reset userData

        dispatch(contratStepSlice.actions.goToContratStep(1)); //go to step 1



        if (currentContrat.Client) {
            console.log(currentContrat)
            //return

            dispatch(contratSlice.actions.setContrat(currentContrat)); //reset contrat
            //dispatch(dureeSlice.actions.setDuree({})); //reset duree

            /*  dispatch(accessoiresSlice.actions.resetPanier()); //reset access
             dispatch(panierSlice.actions.resetPanier()); //reset access */

            fillPanierRedux();
            fillAccessRedux()

            dispatch(checkCGVSlice.actions.setCGV({ index: 1, check: true })); //reset cvg
            dispatch(checkCGVSlice.actions.setCGV({ index: 2, check: true })); //reset cvg
            dispatch(commentaireSlice.actions.setCommentaire(currentContrat.commentaire)); //reset commentaire
            //dispatch(livraisonSlice.actions.setLivraison({})); //reset livraiosn
            dispatch(idSpotLocSlice.actions.setIdSpotLoc(currentContrat.spot_id)); //reset access

            dispatch(periodHeuresSlice.actions.setHeure({ heure: currentContrat.h1, index: 1 })); //reset access
            dispatch(periodHeuresSlice.actions.setHeure({ heure: currentContrat.h2, index: 2 })); //reset access

            dispatch(periodDatesSlice.actions.setDate({ jour: dayjs(currentContrat.date1).format('YYYY-MM-DD'), index: 1 })); //reset access
            dispatch(periodDatesSlice.actions.setDate({ jour: dayjs(currentContrat.date2).format('YYYY-MM-DD'), index: 2 })); //reset access

            dispatch(userDataSlice.actions.setUserData({
                found: true,
                id_client: currentContrat.Client.id_client,
                tel: currentContrat.Client.tel,
                email: currentContrat.Client.email,
                prenom: currentContrat.Client.prenom,
                nom: currentContrat.Client.nom,
                adresse: currentContrat.Client.adresse,
                adresse_comp: currentContrat.Client.adresse_comp,
                cp: currentContrat.Client.cp,
                ville: currentContrat.Client.ville,
                pays: currentContrat.Client.country
            })); //reset userData



        }
    }, [currentContrat])



    function fillPanierRedux() {

        currentContrat.ContratArticles.forEach((article) => {
            let listPrenoms = [];
            let listTailles = [];

            for (let i = 0; i < article.qte; i++) {
                listPrenoms.push(article.prenom[i]);
                listTailles.push(article.taille[i]);
            }
            dispatch(panierSlice.actions.refillArticle({ id_article: article.article_id, qte: article.qte, tailles: listTailles, prenoms: listPrenoms }));
        })

    }

    function fillAccessRedux() {

        currentContrat.ContratAccesses.forEach((article) => {
            dispatch(accessoiresSlice.actions.refillAccess({ id_article: article.article_id, qte: article.qte }));
        })

    }



    const prevStep = (event) => {
        dispatch(contratStepSlice.actions.previousContratStep());
    }
    const nextStep = (event) => {
        dispatch(contratStepSlice.actions.nextContratStep());
    }




    return (
        <main>
            {/* <div >
                <Button variant="contained" onClick={prevStep}>previous step</Button>
                <Button variant="contained" onClick={nextStep}>next step</Button>
            </div> */}



            {/* --------------
                display correct component, based on current shoppinng step :  
                --------------------------*/}

            <BannerMoutchicLoisirs title={"Manager : Outil de réservation de vélos"} />
            <ManagerNavBar idSpotLoc={idSpotLoc} />
            {step === 1 ? <StepOne /> : null}
            {step === 2 ? <StepTwo /> : null}
            {step === 3 ? <StepThree /> : null}
            {step === 4 ? <StepFour /> : null}
            {step === 5 ? <StepFive /> : null}
            {step === 6 ? <StepSix /> : null}
            {step === 7 ? <StepSeven /> : null}

        </main>

    )
}




export default EditContrat